import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

import { CommunicationRoutingModule } from './communication.routing'
import { CommunicationComponent } from './communication.component'
import { ScrollbarModule } from 'ngx-scrollbar'
import { SharedServices } from '../../../services/shared.services'
import { TopCommunicationComponent } from './top-communication/top-communication.component'
import { ListCommunicationComponent } from './list-communication/list-communication.component'
import { NewroomComponent } from './newroom/newroom.component'
import { A2Edatetimepicker } from 'ng2-eonasdan-datetimepicker'
import { NgCircleProgressModule } from 'ng-circle-progress'
import { CommonsModule } from '../../../commons/commons.module'

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        CommunicationRoutingModule,
        ReactiveFormsModule,
        ScrollbarModule,
        A2Edatetimepicker,
        // Specify ng-circle-progress as an import
        NgCircleProgressModule.forRoot({
            // set defaults here
            radius: 100,
            outerStrokeWidth: 16,
            innerStrokeWidth: 8,
            outerStrokeColor: '#0080ff',
            innerStrokeColor: '#53a9ff',
            animationDuration: 300,
        }),
        CommonsModule,
    ],
    declarations: [
        CommunicationComponent,
        TopCommunicationComponent,
        ListCommunicationComponent,
        NewroomComponent,
    ],
    providers: [
        SharedServices,
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
    ],
})
export class CommunicationModule {
}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/communication/communication.module.ts